


























import Vue from 'vue'
import Component from "vue-class-component"

@Component({
  name: "testing-begin"
})
export default class TestingBegin extends Vue{
  private SvgBegin = require('@/assets/images/testing/begin.svg')
}
